import { trigger, state, style, transition, animate } from '@angular/animations'
import { Component, EventEmitter, OnDestroy, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { SiteproviderService } from '../../../services/siteprovider.service';
import { NotificationBarModel, NotificationBarType } from './notificationbar.model';
import { CommonModule } from '@angular/common';

@Component({
  animations: [
    trigger('openClose', [
      state('in', style({
        opacity: 1,
        transform: 'translateY(0)'
      })),
      transition(':enter', [
        style({
          opacity: 0,
          transform: 'translateY(-100%)'
        }),
        animate('200ms ease-in')
      ]),
      transition(':leave', [
        animate('200ms ease-out', style({
          opacity: 0,
          transform: 'translateY(-100%)'
        }))
      ])
    ])
  ],
  selector: 'app-notificationbar',
  imports: [CommonModule],
  templateUrl: './notificationbar.component.html',
  styleUrl: './notificationbar.component.scss'
})

export class NotificationBarComponent implements OnDestroy {

  // Array that holds all notifications in NgFor
  notifications: NotificationBarModel[] = [];

  // Emitters that are subscribed to Events
  @Output() closed = new EventEmitter<any>();
  @Output() action =  new EventEmitter<any>();

  // Type used for each notification. Default values are used if not specified at object creation
  defaultNotification: NotificationBarModel = {
   action: false,
   actionable: true,
   autoHide: true,
   closeable: true,
   hideDelay: 5000,
   hideOnHover: false,
   id: 0,
   isHtml: false,
   message: 'No message',
   type: NotificationBarType.Info,
   typeValue: ''
  }

  // Class used to subscribe notifications to application
  subscription: Subscription;

  //
  constructor(private _sps: SiteproviderService) 
  {
    this.subscription = this._sps.created.subscribe(this.addNotificationBar.bind(this));
  }

  ngOnDestroy() {
    this.subscription.unsubscribe;
  }

  addNotificationBar(notificationBar: NotificationBarModel) {
    
    let newNotificationBar = Object.assign({}, this.defaultNotification, notificationBar);

    if(newNotificationBar !== undefined){
      newNotificationBar.typeValue = NotificationBarType[newNotificationBar.type!].toLowerCase();

      this.notifications.push(newNotificationBar);

      if (newNotificationBar.autoHide) {
        window.setTimeout(() => {
            this.hideNotification(newNotificationBar);
        }, newNotificationBar.hideDelay);
      }
    }
  }

  hideNotification(notificationBar: NotificationBarModel) {
    let index = this.notifications.indexOf(notificationBar);
    this.notifications.splice(index, 1);
  }

  hideOnHover(notificationBar: NotificationBarModel) {
    if (notificationBar.hideOnHover) {
        this.hideNotification(notificationBar);
    }
  }

  onAction(notificationBar: NotificationBarModel, index: number) {
    notificationBar.id = index;
    this.action.emit(notificationBar)
  }

  onClose(notificationBar: NotificationBarModel, index: number) {
    notificationBar.id = index;
    this.hideNotification(notificationBar);
    this.closed.emit(notificationBar);
  }
}
